<template>
  <main class="home">
    <WelcomeView />
    <ManifestoSection />
    <div class="band" aria-hidden="true">
      <MarqueeText class="band__marquee" :items="['Coppados', 'Hecho en Rosario', 'Para gente coppada']" variant="band" :speed="90" />
    </div>
    <TrackSlider />
    <NextDates />
    <RosterGroup />
    <FooterInformation />
  </main>
</template>

<script>
import WelcomeView from '@/views/WelcomeView'
import ManifestoSection from '@/components/ManifestoSection.vue'
import MarqueeText from '@/components/ui/MarqueeText.vue'
import TrackSlider from '@/components/TrackSlider'
import NextDates from '@/components/NextDates'
import RosterGroup from '@/components/RosterGroup.vue'
import FooterInformation from '@/components/FooterInformation'
import { scrollToTarget } from '@/animations/smoothScroll'

export default {
  name: 'PrincipalView',
  components: {
    WelcomeView,
    ManifestoSection,
    MarqueeText,
    TrackSlider,
    NextDates,
    RosterGroup,
    FooterInformation
  },
  mounted() {
    // Llegando desde otra página con /#seccion: esperamos a que carguen los datos.
    const hash = this.$route.hash
    if (hash) {
      this.hashTimer = setTimeout(() => scrollToTarget(hash), 900)
    }
  },
  beforeDestroy() {
    clearTimeout(this.hashTimer)
  }
}
</script>

<style scoped>
.home {
  background: var(--c-bg);
}

.band {
  position: relative;
  z-index: 2;
  padding: 2rem 0;
  overflow: hidden;
  background: var(--c-bg);
}

.band__marquee {
  width: 106%;
  margin-left: -3%;
  transform: rotate(-2deg);
  font-size: clamp(2rem, 1rem + 4vw, 5rem);
  line-height: 1.1;
  text-transform: uppercase;
}
</style>
